import React, {Component} from 'react';
// import {answerBubbleStyle, answerBubbleStyleMobile} from '../../../utils/styles';

class AthOnboardingMultiple extends Component {
    constructor(props){
        super(props);

        this.state = {
          selected: false        
      };
    }

    componentDidUpdate (prevProps) {
      // if (prevProps.)
    }

    handleOnClick = () => {
      if( this.props.isMaxSelectNumber && !this.state.selected ){
        return true
      }
        this.setState({selected: !this.state.selected});
        this.props.handleSelected(this.props.option);
    }

    render() {
      return(
        <li /*style={ answerBubbleStyle }*/ onClick={ this.handleOnClick } className={ this.state.selected  ? "ath-onboarding-multiple-bubble rsc-os-option selected" : "ath-onboarding-multiple-bubble rsc-os-option" }>
          <a>{ this.props.label }</a>
        </li>
      );
    }
}

export default AthOnboardingMultiple;



// WEBPACK FOOTER //
// ./src/ath/components/onboarding/v1/AthOnboardingMultipleBubble.js